<template>
  <div class="km-contact">
    <div class="section-header">
      <div class="section-tag">Contact Us</div>
      <h2 class="section-title">联系我们</h2>
      <p class="section-desc">欢迎您访问本公司官网，如有问题请通过以下方式联系我们</p>
    </div>

    <div class="contact-grid">
      <!-- 联系信息卡片 -->
      <div class="contact-info">
        <div class="info-card" v-for="item in contacts" :key="item.label">
          <div class="info-icon">
            <Icon :type="item.icon" size="22" />
          </div>
          <div class="info-body">
            <span class="info-label">{{ item.label }}</span>
            <span class="info-value">{{ item.value }}</span>
          </div>
        </div>

        <!-- 微信二维码 -->
        <div class="wechat-card">
          <div class="info-icon">
            <Icon type="ios-chatbubbles" size="22" />
          </div>
          <div class="info-body">
            <span class="info-label">微信扫码联系</span>
            <div class="wechat-qr">
              <img src="/assets/wechat.png" alt="微信二维码" />
            </div>
          </div>
        </div>
      </div>

      <!-- 地图区域 -->
      <div class="contact-map">
        <div class="map-header">
          <Icon type="ios-navigate" size="18" class="map-icon" />
          <span>宁国市经济技术开发区众益广场8幢101号</span>
        </div>
        <div class="map-wrapper">
          <el-amap vid="amapDemoContact" :bubble="true" :zoom="zoom" :center="center" @click="handleClick">
            <el-amap-marker :position="[119.034127, 30.649705]" />
          </el-amap>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      zoom: 15,
      center: [119.034127, 30.649705],
      contacts: [
        { icon: 'ios-call', label: '联系电话', value: '13865300917' },
        { icon: 'ios-call-outline', label: '固定电话', value: '0563-4301737' },
        { icon: 'ios-mail', label: '电子邮箱', value: 'ningguokemei@163.com' },
        { icon: 'ios-navigate', label: '公司地址', value: '宁国市经济技术开发区众益广场8幢101号' },
      ],
    };
  },
  methods: {
    handleClick(e) {
      console.log(e);
    },
  },
};
</script>

<style scoped lang="less">
.km-contact {
  width: 100%;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 32px;
  align-items: start;
}

/* 联系信息 */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-card,
.wechat-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 20px;
  background: var(--bg-primary);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-xs);
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(255, 140, 0, 0.3);
    box-shadow: var(--shadow-sm);
    transform: translateX(4px);
  }
}

.info-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, var(--primary), var(--primary-light));
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
  box-shadow: var(--shadow-primary);
}

.info-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
}

.info-label {
  font-size: 12px;
  color: var(--text-muted);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 600;
  word-break: break-word;
  line-height: 1.4;
}

/* 微信二维码 */
.wechat-qr {
  margin-top: 8px;

  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
    border-radius: 6px;
    border: 1px solid var(--border-color);
  }
}

/* 地图区域 */
.contact-map {
  background: var(--bg-primary);
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.map-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  background: var(--primary);
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;

  .map-icon {
    color: #ff8c00;
    flex-shrink: 0;
  }
}

.map-wrapper {
  height: 340px;
  width: 100%;
}

/* 响应式 */
@media (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .map-wrapper {
    height: 260px;
  }

  .info-card,
  .wechat-card {
    padding: 14px 16px;
  }

  .info-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
  }
}

@media (max-width: 480px) {
  .map-wrapper {
    height: 220px;
  }

  .info-value {
    font-size: 13px;
  }
}
</style>
